import splitExtension from './splitExtension.helper';

const getPdfFilename = (name: string, resolvedFilename?: string) =>
  resolvedFilename ?? `${splitExtension(name)[0]}.pdf`;

export default getPdfFilename;
